import moment from 'moment';
import fields from "./fields.utils.js";


const schema_goods_in_transit = {
    ...fields.notes,
    //source
    "source_uuid": {
        type: 'select',
        label: 'source',
        value: '',
        options: [],
        required: true
    },
    "address1": {
        label: "Address Line 1",
        placeholder: "Address Line 1",
        value: '',
        type: "text",
        required: true,


    },
    "address2": {
        label: "Address Line 2",
        placeholder: "Address Line 2",
        value: '',
        type: "text",

    },
    "address3": {
        label: "Address Line 3",
        placeholder: "Address Line 3",
        type: "text",
        value: '',

    },
    "address4": {
        label: "Address Line 4",
        placeholder: "Address Line 4",
        type: "text",
        value: '',

    },
    "city": {
        label: "City",
        placeholder: "City",
        type: "text",
        value: '',
        required: true,

    },
    "postcode": {
        label: 'Postal Code',
        placeholder: 'Postal Code',
        type: "address-lookup",
        value: '',
        required: true,

    },
    "first_name": {
        label: "First Name",
        placeholder: "First Name",
        type: "text",
        value: '',
        required: true,

    },
    "last_name": {
        label: "Last Name",
        placeholder: "Last Name",
        type: "text",
        value: '',
        required: true,

    },
    "date_of_birth": {
        label: 'Date of birth',
        type: 'date-mask',
        value: '',
        required: true,

        placeholder: 'Date of Birth'
    },
    "employment_status": {
        type: 'select',
        label: `employment status`,
        value: '',
        options: [],
        required: true
    },
    "occupation_x_type": {
        value: '',
        type: 'auto-suggest',
        required: true,
        options: [],
    },

    "email": {
        label: 'Email Address',
        placeholder: 'Email Address',
        type: 'email',
        value: '',

    },
    "telephone": {
        label: "Telephone",
        placeholder: "Telephone",
        type: "text",
        value: '',
        required: true,

    },
    "cover_duration": {
        label: 'Cover Duration',
        type: 'select',
        value: '',
        options: [],
        required: true,

    },
    "cover_level": {
        label: 'Cover Level',
        type: 'number',
        value: '',
        required: true,
    },
    "use_covered": {
        label: 'Covered',
        type: 'select',
        value: '',
        options: [],
        required: true,

    },
    "company_name": {
        label: 'Company Name',
        type: 'text',
        value: '',
    },
    "company_year": {
        label: "company establishment date (Year)",
        type: 'date-mask',
        mask: '9999',
        value: moment().format('YYYY'),
        required: true,

        placeholder: 'Company year'
    },
    ...fields.marketing,
    ...fields.title,
    ...fields.cross_selling
};
export default schema_goods_in_transit;
